export default function mapAttributesSegments(segmentsGeometry, segments) {
  const res = [];

  segmentsGeometry.forEach((sg, idx) => {
    res.push({ ...segments[idx], geometry: sg.segment });
  });

  return res;
}
